module.exports = __webpack_public_path__ + "static/media/bullet.52976044.svg";